import { devModeEnabled } from "@/lib/auth";

// Lightweight, side-effect-free auth state used by the router's beforeLoad gate.
// The full FlowUser is owned by useAuth() (React state); this module only answers "is logged in?".

// Seed from localStorage at module-init: oidc-client-ts persists the session
// under `oidc.user:<issuer>:<client_id>`. Without this seed, a deep-link page
// load (e.g. /submit/<id>) flips to false synchronously in beforeLoad before
// useAuth gets a chance to refill it asynchronously, which triggers a redirect
// to /login — followed by LoginPage seeing the cached session and trying to
// bounce back, ad infinitum.
function hasCachedOidcSession(): boolean {
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith("oidc.user:")) {
        const raw = localStorage.getItem(key);
        if (raw && raw.length > 0) return true;
      }
    }
  } catch {
    /* localStorage unavailable (SSR / privacy mode); fall through */
  }
  return false;
}

let authed = hasCachedOidcSession();

export const authStore = {
  set(value: boolean) {
    authed = value;
  },
  isAuthenticated(): boolean {
    if (devModeEnabled()) return true;
    return authed;
  },
};
